module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/4/1-e8c72a0b4572d70fa383502f4cd91ae9.jpg";